import type { OrderStatus } from '../orders/orders.ts';

export type ParcelListKind = 'returned' | 'missing';

export const PARCEL_COLUMN_IDS = [
  'order',
  'customer',
  'destination',
  'barcode',
  'carrier',
  'carrierStatus',
  'cod',
  'status',
] as const;

export const RETURN_STATUSES = [
  'RETURNING',
  'RETURNED',
  'RETURN_RECEIVED',
] as const satisfies readonly OrderStatus[];

export type ReturnStatus = (typeof RETURN_STATUSES)[number];
